import { AdsClick } from "@mui/icons-material";
import { Avatar, Box, Typography } from "@mui/material";
import React, { useEffect } from "react";

export default ({
  actionParameters,
  setActionParameters,
  setValidForm,
}: {
  actionParameters: any;
  setActionParameters: (p: any) => void;
  setValidForm: (b: boolean) => void;
  getToken: () => Promise<string>;
  companyId: string;
}) => {
  // Form is always valid since no configuration is needed
  useEffect(() => {
    setValidForm(true);
  }, [setValidForm]);

  return (
    <div>
      <div style={{ marginTop: "24px" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
          <Avatar
            sx={{ width: 40, height: 40, bgcolor: "primary.main" }}
            variant="rounded"
          >
            <AdsClick />
          </Avatar>
          <Typography variant="h6">Audience Contact Enrichment</Typography>
        </Box>
        <Typography variant="body2" color="text.secondary">
          This action uses the platform&apos;s Audience integration to
          automatically enrich your contact data. No additional configuration is
          required.
        </Typography>
      </div>

      <div style={{ marginTop: "24px" }}>
        <Typography variant="subtitle1">Matching Requirements</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          To find a match, you need <strong>one</strong> of the following:
        </Typography>
        <ul
          style={{
            marginTop: "8px",
            paddingLeft: "20px",
            color: "text.secondary",
          }}
        >
          <li>
            <strong>Email</strong> - matches directly
          </li>
          <li>
            <strong>Phone</strong> - matches directly
          </li>
          <li>
            <strong>LinkedIn URL</strong> - matches directly
          </li>
          <li>
            <strong>First Name + Last Name + Company</strong> - requires all three
          </li>
          <li>
            <strong>First Name + Last Name + Website/Domain</strong> - requires all three
          </li>
          <li>
            <strong>First Name + Last Name + Zip Code</strong> - requires all three
          </li>
        </ul>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1, fontStyle: "italic" }}>
          Note: First name and last name alone are not sufficient for matching -
          additional context like company, website, or zip code is required.
        </Typography>
      </div>

      <div style={{ marginTop: "24px" }}>
        <Typography variant="subtitle1">Fields Enriched</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Up to 75 fields can be enriched. New columns are automatically created
          for any fields not already in your list. Common fields include:
        </Typography>
        <Box sx={{ display: "flex", gap: 4, mt: 1, flexWrap: "wrap" }}>
          <ul
            style={{
              marginTop: "8px",
              paddingLeft: "20px",
              color: "text.secondary",
            }}
          >
            <li>Email (Personal & Work)</li>
            <li>Phone (Mobile & Work)</li>
            <li>LinkedIn URL</li>
            <li>Job Title / Headline</li>
            <li>First Name / Last Name</li>
            <li>Full Address</li>
          </ul>
          <ul
            style={{
              marginTop: "8px",
              paddingLeft: "20px",
              color: "text.secondary",
            }}
          >
            <li>Company Name & Website</li>
            <li>Company Industry</li>
            <li>Company Size</li>
            <li>Company Revenue</li>
            <li>Company Founded Year</li>
            <li>Company LinkedIn</li>
          </ul>
          <ul
            style={{
              marginTop: "8px",
              paddingLeft: "20px",
              color: "text.secondary",
            }}
          >
            <li>Gender / Age / Birth Date</li>
            <li>Education & Schools</li>
            <li>Skills & Interests</li>
            <li>Social Profiles</li>
            <li>Net Worth & Income</li>
            <li>And many more...</li>
          </ul>
        </Box>
      </div>
    </div>
  );
};
